// Generated by ReScript, PLEASE EDIT WITH CARE

import * as MomentTimezone from "moment-timezone";

function clone(b, a) {
  return b.default(a);
}

function guess(param) {
  return MomentTimezone.tz.guess();
}

function zone(timeZone) {
  return MomentTimezone.tz.zone(timeZone);
}

function add(timeZone) {
  MomentTimezone.tz.add(timeZone);
}

function format(f, tz) {
  return tz.format(f);
}

function tzFunc(date, zone, t) {
  return t.tz(date, zone);
}

function momentFormat(date, dateFormat) {
  return MomentTimezone.tz(date, MomentTimezone.tz.guess()).format(dateFormat);
}

var setSingaporeTimeZoneCode = "Asia/Singapore|LMT SMT +07 +0720 +0730 SGT SGT|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so1u|56e5";

function init(param) {
  MomentTimezone.tz.add([setSingaporeTimeZoneCode]);
}

var computerLocalDate = "DD MMM YYYY | hh:mm A z";

export {
  clone ,
  guess ,
  zone ,
  add ,
  format ,
  tzFunc ,
  computerLocalDate ,
  momentFormat ,
  setSingaporeTimeZoneCode ,
  init ,
}
/* moment-timezone Not a pure module */
